/**
 * https://support.pendo.io/hc/en-us/articles/360046272771-Developer-s-Guide-To-Installing-the-Pendo-Snippet
 */

export default {
  // Inits the variable window.pendo
  load: (pendoApiKey) => {
    (function (p, e, n, d, o) {
      let w, x;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      const v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; w += 1) {
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
        })(v[w]);
      }
      const y = e.createElement(n);
      y.async = !0;
      y.src = `https://cdn.pendo.io/agent/static/${pendoApiKey}/pendo.js`;
      const z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  },
  initialize: (user, instance) => {
    window.pendo.initialize({
      visitor: {
        id: user?.toLowerCase(), // Required if user is logged in <--- Aquí poner el correo del usuario
        // email:        // Recommended if using Pendo Feedback, or NPS Email
        // full_name:    // Recommended if using Pendo Feedback
        // role:         // Optional

        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      },

      account: {
        id: instance?.toLowerCase(), // Highly recommended <-- poner algo que sea fijo por ejemplo la instancia
        // name:         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
    });
  },
};
